<div class="main-content side-content pt-0 ml-0">
  <div class="main-container container-fluid">
    <div class="inner-body">
      <div class="row row-sm add-form">
        <form autocomplete="off" class="p-0" novalidate [formGroup]="optionalForm">
          <div class="col-lg-12 col-md-12">
            <div class="card custom-card">
              <div class="card-body">
                <div class="mb-3 col">
                  <h3 class="main-content-label mb-1"><b>Optional Subject Selection</b></h3>
                </div>
                <hr>
                <div class="row clearfix mt-3">
                  <div class="row clearfix">
                    <div class="col-sm-2">
                      <div class="form-group">
                        <mat-form-field appearance="outline" class="example-full-width">
                          <mat-label>Session</mat-label>
                          <mat-select disabled #select232 placeholder="Session" class="colorblack" formControlName="SubSession">
                            <mat-select-filter *ngIf="select232.focused" [placeholder]="'Filter'" [displayMember]="'SnName'"
                              [array]="sessionList" (filteredReturn)="SessionFilterList = $event"></mat-select-filter>
                            <mat-option *ngFor="let item of SessionFilterList" [value]="item.SnNo">
                              {{item.SnName}}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                    </div>
                    <div class="col-sm-2">
                      <div class="form-group">
                        <mat-form-field appearance="outline" class="example-full-width">
                          <mat-label>Faculty</mat-label>
                          <mat-select disabled #select33 placeholder="FcCode" class="colorblack" formControlName="SubFacId">
                            <mat-select-filter *ngIf="select33.focused" [placeholder]="'Filter'" [displayMember]="'FcDesc'"
                              [array]="facultyList" (filteredReturn)="filteredFacultyList = $event"></mat-select-filter>
                            <mat-option *ngFor="let item of filteredFacultyList" [value]="item.FcCode"
                              (click)="getCourseData(item.FcCode)">
                              {{item.FcDesc}}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                    </div>
                    <div class="col-sm-3">
                      <div class="form-group">
                        <mat-form-field appearance="outline" class="example-full-width">
                          <mat-label>Course</mat-label>
                          <mat-select disabled #select34 placeholder="CoCode" class="colorblack" formControlName="SubCoId">
                            <mat-select-filter *ngIf="select34.focused" [placeholder]="'Filter'" [displayMember]="'CoName'"
                              [array]="courseList" (filteredReturn)="filteredCourseList = $event"></mat-select-filter>
                            <mat-option *ngFor="let item of filteredCourseList" [value]="item.CoCode"
                              (onSelectionChange)="getExamStreamData(item.CoCode)">
                              {{item.CoName}}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                    </div>
                    <div class="col-sm-2">
                      <div class="form-group">
                        <mat-form-field appearance="outline" class="example-full-width">
                          <mat-label>Branch</mat-label>
                          <mat-select disabled #select35 placeholder="StrName" class="colorblack" formControlName="SubBrId">
                            <mat-select-filter *ngIf="select35.focused" [placeholder]="'Filter'" [displayMember]="'StrName'"
                              [array]="courseStreamList" (filteredReturn)="filteredStreamList = $event"></mat-select-filter>
                            <mat-option *ngFor="let item of filteredStreamList" [value]="item.StrId"
                              (onSelectionChange)="getBrId(item.StrId, item.StrCode)">
                              {{item.StrName}}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                    </div>
                    <div class="col-sm-2">
                      <div class="form-group">
                        <mat-form-field appearance="outline" class="example-full-width">
                          <mat-label>Exam</mat-label>
                          <mat-select #select36 class="colorblack" formControlName="SubEmId"
                            (selectionChange)="onExamChange($event)">
                            <mat-select-filter *ngIf="select36.focused" [placeholder]="'Filter'" [displayMember]="'EmName'"
                              [array]="examList" (filteredReturn)="filteredExamList = $event"></mat-select-filter>
                            <mat-option *ngFor="let item of filteredExamList" [value]="item.EmId">
                              {{item.EmName}}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                    </div>
                    <div class="col-sm-2">
                      <div class="form-group">
                        <mat-form-field appearance="outline" class="example-full-width">
                          <mat-label>College</mat-label>
                          <mat-select disabled #select38 class="colorblack" formControlName="SubCgId">
                            <mat-select-filter *ngIf="select38.focused" [placeholder]="'Filter'" [displayMember]="'CgName'"
                              [array]="stucourseClgMapList" (filteredReturn)="filteredstucourseClgMapListList = $event"></mat-select-filter>
                            <mat-option *ngFor="let item of filteredstucourseClgMapListList" [value]="item.CgCode"
                              (click)="scrutenylevelCheck(item)" (click)="cutoff(item.CgCode)">
                              {{item.CgName}}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row clearfix mt-3">
                  <div class="col-sm-12">
                    <div class="flex-container">
                      <div *ngIf="OptSub && GroupData.length > 0">
                        <div class="card-container" style="display: flex; flex-direction: row; flex-wrap: wrap;">
                          <mat-card *ngFor="let group of GroupData" class="example-card2" style="margin: 10px; min-width: 280px;">
                            <mat-checkbox *ngIf="group.EsOpCode && group.EsOpCode !== ' '"
                              [disabled]="group.EsOpCode === ' '"
                              [checked]="shouldCheckItemForGroup(group) || group.EsOpCode === ' '"
                              (change)="onCheckboxChanged($event, group)">
                              <h5>{{ group.EsCode }} - {{ group.EsName }}
                                <b *ngIf="group.EsOpCode !== ' '">(Option : {{group.EsOpCode}})</b>
                              </h5>
                            </mat-checkbox>
                            <h5 *ngIf="!group.EsOpCode || group.EsOpCode === ' '">
                              {{ group.EsCode }} - {{ group.EsName }}
                            </h5>
                            <mat-card-content>
                              <div *ngFor="let child of group.children">
                                <mat-checkbox [disabled]="child.EsOpCode === ' '"
                                  [checked]="shouldCheckItemForGroup(child) || child.EsOpCode === ' '"
                                  (change)="onCheckboxChanged($event, child)">
                                  {{ child.EsCode }} - {{ child.EsName }}
                                  <b *ngIf="child.EsOpCode !== ' '">(Option : {{child.EsOpCode}})</b>
                                </mat-checkbox>
                              </div>
                            </mat-card-content>
                          </mat-card>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="mt-4">
                  <ng-container *ngIf="getValidationErrorsKeys().length > 0; else optDataSection">
                    <div *ngFor="let errorCode of getValidationErrorsKeys()">
                      <p style="color: red;">{{ validationErrors[errorCode] }}</p>
                    </div>
                  </ng-container>
                  <ng-template #optDataSection>
                    <div class="col-sm-12" *ngFor="let opt of optData">
                      <h6 class="mb-1 redCol">
                        <b>For OptCode = {{opt.OpCode}} : Min = {{opt.OpMin}} And Max = {{opt.OpMax}}</b>
                      </h6>
                    </div>
                  </ng-template>
                </div>

                <div class="red" *ngIf="msgShow">Note : {{Message}}</div>
                <div class="red" *ngIf="msgFail">Note : {{Message2}}</div>

                <div class="row mb-2 prpl">
                  <div class="col-sm-12">
                    <button type="button" *ngIf="submitButton" [disabled]="disableButton"
                      class="btn btn-primary btn-icon-text fr sz floatright mt-1" (click)="submitSelection()">
                      <span><img width="20vh" src="../../assets/images/save.gif" style="margin-right: 5px;"> Save</span>
                    </button>
                    <button type="button" (click)="submitSelection()" [disabled]="disableButton" *ngIf="updateButton"
                      class="btn btn-primary btn-icon-text fr sz floatright mt-1">
                      <span><img width="20vh" src="../../assets/images/edit.gif" style="margin-right: 5px;"> Update</span>
                    </button>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>